module.exports = __webpack_public_path__ + "static/img/case2.8d261b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/case2.png
// module id = MAsT
// module chunks = 1